export default __webpack_public_path__ + "static/media/SWT0120.34I-27106_-16408_0.462b2170.jpg";